module.exports = __webpack_public_path__ + "img/text1.cf0777dc.png";